import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Error } from '../../../../../../types/paymentVerification';
import Alert from '../../../../../Alert/Alert';

import {
  TXTWCL_An_error_occurred_with_your_up_ELL,
  TXTWCL_File_exceeds_size_limitX_Pleas_ELL,
  TXTWCL_Unsupported_file_typeX_Please__ELL,
  TXTWCL_You_canXt_upload_files_that_sh_ELL,
  TXTWCL_You_can_only_upload_five_files_ELL,
  TXTWCL_You_need_to_upload_a_fileX
} from './UploadError.messages.json';
import { errorAlert, wrapper } from './UploadError.scss';

interface Props {
  error: string;
}

const UploadError: React.FC<Props> = ({ error }) => {
  let translationText;
  switch (error) {
    case Error.Duplicate:
      translationText = <Translation {...TXTWCL_You_canXt_upload_files_that_sh_ELL} />;
      break;
    case Error.MaxFiles:
      translationText = <Translation {...TXTWCL_You_can_only_upload_five_files_ELL} />;
      break;
    case Error.Type:
      translationText = <Translation {...TXTWCL_Unsupported_file_typeX_Please__ELL} />;
      break;
    case Error.Size:
      translationText = <Translation {...TXTWCL_File_exceeds_size_limitX_Pleas_ELL} />;
      break;
    case Error.UploadFile:
      translationText = <Translation {...TXTWCL_You_need_to_upload_a_fileX} />;
      break;
    default:
      translationText = <Translation {...TXTWCL_An_error_occurred_with_your_up_ELL} />;
      break;
  }

  return (
    <div className={wrapper}>
      <Alert className={errorAlert} variant="error">
        {translationText}
      </Alert>
    </div>
  );
};

export default UploadError;
